import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { PageLoader } from "./common/ui";

/* Route guard. Pass allowedRoles to restrict; omit to allow any authenticated user. */
export default function ProtectedRoute({ children, allowedRoles }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return <PageLoader label="Checking your session" />;

  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    // Send non-staff users to their customer dashboard; staff without access -> admin home.
    const fallback = user.role === "customer" ? "/dashboard" : "/admin";
    return <Navigate to={fallback} replace />;
  }

  return children;
}
